var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const CloseIcon = (_a) => {
    var { color = "#5e6c84", size } = _a, props = __rest(_a, ["color", "size"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24" }, props),
        React.createElement("g", { transform: "translate(-1024 -240)" },
            React.createElement("g", { transform: "translate(1024 240)" },
                React.createElement("rect", { fill: "none", width: size, height: size }),
                React.createElement("path", { fill: color, d: "M14.857,9.143H9.143v5.714a1.143,1.143,0,1,1-2.286,0V9.143H1.143a1.143,1.143,0,1,1,0-2.286H6.857V1.143a1.143,1.143,0,1,1,2.286,0V6.857h5.714a1.143,1.143,0,1,1,0,2.286Z", transform: "translate(12 0.686) rotate(45)" })))));
};
//# sourceMappingURL=Close.js.map